import { DateTime, Settings } from 'luxon';

/**
 * Given a date range, if it is within the same day,
 * return the following format: yyyy-MM-dd HH:mm - HH:mm
 * else returns yyyy-MM-dd HH:mm - yyyy-MM-dd HH:mm
 * @param {*} fromISO
 * @param {*} toISO
 */

var formatDateTimeRange = function formatDateTimeRange(fromISO, toISO) {
  var DATE_FORMAT = 'yyyy-MM-dd';
  var TIME_FORMAT = 'HH:mm'; // both dates are not defined

  if (!fromISO && !toISO) {
    return '';
  }

  if (!fromISO || !toISO) {
    // either from or to not defined
    if (!fromISO) {
      return "".concat(DateTime.fromISO(toISO).toFormat("".concat(DATE_FORMAT, " ").concat(TIME_FORMAT)));
    }

    return "".concat(DateTime.fromISO(fromISO).toFormat("".concat(DATE_FORMAT, " ").concat(TIME_FORMAT)));
  }

  var fromDate = DateTime.fromISO(fromISO).toFormat(DATE_FORMAT);
  var toDate = DateTime.fromISO(toISO).toFormat(DATE_FORMAT);

  if (fromDate === toDate) {
    return "".concat(fromDate, " ").concat(DateTime.fromISO(fromISO).toFormat(TIME_FORMAT), " - ").concat(DateTime.fromISO(toISO).toFormat(TIME_FORMAT));
  }

  return "".concat(DateTime.fromISO(fromISO).toFormat("".concat(DATE_FORMAT, " ").concat(TIME_FORMAT)), " - ").concat(DateTime.fromISO(toISO).toFormat("".concat(DATE_FORMAT, " ").concat(TIME_FORMAT)));
};

var formatDateTime = function formatDateTime(dateTimeISO) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd HH:mm';
  if (!dateTimeISO) return '';
  var createdDateTime = DateTime.fromISO(dateTimeISO);
  return createdDateTime.toFormat(format);
};
/**
 *
 * @param {Record<String, number>} config
 * @returns {string}
 */


var getCurrentDateTimeISO = function getCurrentDateTimeISO(config) {
  var dateTime = config ? DateTime.now().set(config) : DateTime.now();
  return dateTime.toISO();
};
/**
 *
 * @param {DateTime} dateTime
 * @returns {string}
 */


var convertDateTimeToUtcISO = function convertDateTimeToUtcISO(dateTime) {
  return dateTime.toUTC().toISO();
};

var setupGlobalTimeZone = function setupGlobalTimeZone(timeZone) {
  // Configure the time zone
  Settings.defaultZone = timeZone;
};

export { convertDateTimeToUtcISO, formatDateTime, formatDateTimeRange, getCurrentDateTimeISO, setupGlobalTimeZone };
